<template>
  <!-- 相關文章 -->
  <v-sheet class="related-blogs-swiper" elevation="0" rounded>
    <div class="sheet-header d-flex justify-space-between">
      <p class="header-title">{{ $t('related_blogs_title') }}</p>

      <div class="swiper-btn-group d-flex">
        <v-btn
          class="swiper-button swiper-prev mr-3 pa-0"
          :class="{ hidden: disabledPrevBtn }"
          min-width="32"
          height="32"
          variant="text"
          aria-label="Prev Button"
          @click="prevSwiper"
        >
          <funnow-icon max-width="24" :image-path="'chevron-left.svg'" />
        </v-btn>

        <v-btn
          class="swiper-button swiper-next pa-0"
          :class="{ hidden: disabledNextBtn }"
          min-width="32"
          height="32"
          variant="text"
          aria-label="Next Button"
          @click="nextSwiper"
        >
          <funnow-icon max-width="24" :image-path="'chevron-right.svg'" />
        </v-btn>
      </div>
    </div>

    <div class="swiper__container mt-2">
      <swiper
        ref="relatedBlogsSwiper"
        class="swiper !wd-z-0"
        v-bind="swiperOption"
        @swiper="initSwiper"
        @slide-change-transition-end="onSlideChangeEnd"
      >
        <swiper-slide v-for="blog in items" :key="blog.id">
          <a :href="getBlogURL(blog.id)">
            <v-card class="blog-card" flat>
              <v-img class="blog-image" :src="getImage(blog.cover_image)" max-width="380" height="195" />

              <div class="card-title pl-2">
                <funnow-icon class="mr-2" max-width="16" :image-path="'calendar-icon_black.svg'" />
                {{ formatDateTime(blog.create_time) }}
              </div>

              <p class="blog-title">
                {{ blog.subject }}
              </p>
            </v-card>
          </a>
        </swiper-slide>
      </swiper>
    </div>
  </v-sheet>
</template>

<script>
import { mapGetters } from 'vuex'

import { Swiper, SwiperSlide } from 'swiper/vue'

import FunnowIcon from '@/components/icons/funnow-icon'

export default {
  name: 'RelatedBlogsSwiper',
  components: {
    Swiper,
    SwiperSlide,
    FunnowIcon,
  },
  props: {
    items: { type: Array, default: () => [] },
  },
  setup() {
    const { swiper, disabledPrevBtn, disabledNextBtn, initSwiper, prevSwiper, nextSwiper, switchSwiperBtnStatus, onResize, onSlideChangeEnd } =
      useSwiperFactory()

    return {
      swiper,
      disabledPrevBtn,
      disabledNextBtn,
      initSwiper,
      prevSwiper,
      nextSwiper,
      switchSwiperBtnStatus,
      onResize,
      onSlideChangeEnd,
    }
  },
  data() {
    return {
      hiddenSwiperBeginning: true,
      hiddenSwiperEnd: false,
      swiperOption: {
        width: 389,
        spaceBetween: 20,
      },
    }
  },
  computed: {
    ...mapGetters({}),
  },
  watch: {},
  mounted() {},
  methods: {
    getImage(path) {
      return `${this.$config.public.CDN_URI}${path}`
    },
    getBlogURL(blogID) {
      return `${this.$config.public.BLOG_HOME_URI}/blog/${blogID}`
    },
    formatDateTime(dateTime) {
      return this.$dayjs(dateTime).format('YYYY/MM/DD')
    },
  },
}
</script>

<style scoped lang="scss">
.related-blogs-swiper {
  padding: 16px 0;

  .sheet-header {
    padding: 12px 20px;

    .header-title {
      margin-bottom: 0;
      font-size: 20px;
      font-weight: bold;
      line-height: 28px;
      color: $black50;
    }

    .swiper-btn-group {
      .swiper-button {
        &.hidden {
          visibility: hidden;
        }
      }
    }
  }

  .swiper__container {
    margin-bottom: 40px;
    padding: 12px 20px;

    .blog-card {
      .blog-image {
        border-radius: 4px;
      }

      .card-title {
        margin: 12px 0 8px;
        display: flex;
        align-items: center;
      }

      .blog-title {
        margin-bottom: 0;
        font-size: 17px;
        font-weight: bold;
        line-height: 24px;
        color: $black50;
      }
    }
  }
}
</style>
